//garment.ts — immutable description of one try-on item plus its prompt

import { type GarmentSlot, referent, usesAddPattern } from './garmentSlot'

export interface Garment {
	readonly id: string
	//Combined "Title · Colour", used for tooltips and diagnostics.
	readonly name: string
	//Kept separate so a tile can set them on their own lines instead of truncating one string.
	readonly productTitle: string
	readonly colour: string | null
	readonly slot: GarmentSlot
	//Colour, material, texture, pattern and fit. This is what Lucy actually reads.
	readonly detail: string
	readonly imageURL: string | null
	//Asks Lucy to expand a thin prompt server-side. Used for synced products, whose
	//descriptions are often empty, rather than adding an LLM to the kiosk.
	readonly enrichPrompt: boolean
	readonly priceLabel: string | null
	readonly isAvailable: boolean
}

export function garmentPrompt(garment: Garment): string {
	return usesAddPattern(garment.slot)
		? `Add ${garment.detail} to the person`
		: `Substitute ${referent(garment.slot)} with ${garment.detail}`
}
